// extracted by mini-css-extract-plugin
export default {"image_section":"addonExampleCard_image_section__P0cBN","example_setail_section":"addonExampleCard_example_setail_section__PGYJ9"};